/* eslint-disable */

import Vue from 'vue'
import VueRouter from 'vue-router'

import Start from './views/Start'
import TermsOfUse from './views/TermsOfUse'
import Result from './views/Result'
import Bulk from './views/Bulk'
import Results from './views/Results'
import Token from './views/Token'
import Companies from './views/Companies.vue'
import {
  authenticate,
  hasOidcCallbackParams,
  stripOidcCallbackParams
} from '../auth'
import { loadTermsOfUseAcceptanceFromBackend, termsOfUseAccepted } from '../agb'
import { OIDC_ENABLED } from '../config'

Vue.use(VueRouter)

function toArray(param) {
  if (param) {
    return Array.isArray(param) ? param : [param]
  }
  return []
}

/**
 * Continue navigation, stripping stale OIDC callback params from the URL when
 * authentication already succeeded (replace navigation avoids guard re-entry loops).
 */
function proceedAfterAuth(to, next, redirect) {
  if (redirect) {
    return next(redirect)
  }
  if (OIDC_ENABLED && hasOidcCallbackParams(to.query)) {
    return next({
      name: to.name,
      params: to.params,
      query: stripOidcCallbackParams(to.query),
      hash: to.hash,
      replace: true
    })
  }
  return next()
}

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Start',
      component: Start
    },
    {
      path: '/agb',
      name: 'TermsOfUse',
      component: TermsOfUse
    },
    {
      path: '/result/:search(\\d{1,14})',
      name: 'Result',
      component: Result,
      props: route => ({
        back: route.query.bulk !== undefined,
        search: route.params.search
      })
    },
    {
      path: '/companies',
      name: 'Companies',
      component: Companies,
      beforeEnter: (to, from, next) => {
        if (to.query.q) {
          next()
        } else {
          next({ name: 'Start' })
        }
      },
      props: route => ({
        query: JSON.parse(decodeURI(route.query.q))
      })
    },
    {
      path: '/bulk',
      name: 'Bulk',
      component: Bulk
    },
    {
      path: '/bulk/results',
      name: 'Results',
      component: Results,
      props: route => ({
        gtins: toArray(route.query.g)
      })
    },
    {
      path: '/token',
      name: 'Token',
      component: Token
    },
    {
      path: '/callback',
      name: 'OidcCallback',
      component: () => import('@/router/views/OidcCallback.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import('@/router/views/LogoutView.vue'),
      meta: { requiresAuth: false }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const code = to.query.code
  const state = to.query.state
  const error = to.query.error

  // OIDC error from IdP → redirect to logout for cleanup
  if (error && OIDC_ENABLED) {
    return next({ name: 'Logout' })
  }

  // Pass-through for callback/logout (they handle their own auth)
  if (to.name === 'OidcCallback' || to.name === 'Logout') {
    return next()
  }

  let success = false
  try {
    success = await authenticate(code, state)
  } catch (e) {
    console.error('Authentication error:', e)
    if (OIDC_ENABLED) {
      return next({ name: 'Logout' })
    }
  }

  // If a code was present but authentication failed, redirect to logout
  // for cleanup.  If no code was present, authenticate() has already
  // initiated a redirect to the identity provider — do not override it.
  if (!success && OIDC_ENABLED && code) {
    return next({ name: 'Logout' })
  }

  if (!termsOfUseAccepted() && success) {
    loadTermsOfUseAcceptanceFromBackend().then(() => {
      if (termsOfUseAccepted() || to.name === 'TermsOfUse') {
        proceedAfterAuth(to, next)
      } else {
        proceedAfterAuth(to, next, {
          name: 'TermsOfUse',
          query: stripOidcCallbackParams(
            Object.assign({}, to.query, from.query)
          )
        })
      }
    })
  } else if (success) {
    proceedAfterAuth(to, next)
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js